import React from 'react';
import { CalendarDays, ChevronRight, Images, MapPin } from 'lucide-react';
import EditableTitle from '../pages/EditableTitle';

const Hero = ({
  cliente,
  isAdmin,
  coverImage,
  upcomingCount = 0,
  onSaveTitle,
  onSaveDescription,
  onExplore,
  onBrowseSpace,
  onRequestQuote,
}) => {
  const location = [cliente?.city, cliente?.province].filter(Boolean).join(', ');
  const label = cliente?.organizationLabel || cliente?.organizationShortLabel || 'Espacio PASSAR';
  const hasCustomTitle = Boolean(cliente?.texts?.welcomeTitle?.trim());
  const hasDescription = Boolean(cliente?.description?.trim());
  const exploreLabel = cliente?.organizationType === 'sports' ? 'Ver torneos' : 'Ver eventos';

  return (
    <section className="relative mb-20 overflow-hidden border border-white/10 bg-[#111111]">
      <div className="grid min-h-[620px] lg:grid-cols-[minmax(0,0.95fr)_minmax(380px,1.05fr)]">
        <div className="relative flex flex-col justify-between px-6 py-8 sm:px-10 sm:py-12 lg:px-14 lg:py-14">
          <div>
            <div className="mb-10 flex items-center gap-3">
              {cliente?.logoUrl ? (
                <img
                  src={cliente.logoUrl}
                  alt={`Logo de ${cliente?.nombre || 'este espacio'}`}
                  className="h-12 w-12 rounded-full border border-white/10 object-cover"
                />
              ) : (
                <span className="h-2.5 w-2.5 rounded-full bg-primary-orange" aria-hidden="true" />
              )}
              <span className="text-[11px] font-black uppercase tracking-[2px] text-white/55">{label}</span>
            </div>

            {hasCustomTitle || isAdmin ? (
              <EditableTitle
                as="p"
                className="mb-4 text-sm font-bold uppercase tracking-[1px] text-primary-orange"
                value={cliente?.texts?.welcomeTitle}
                placeholder="Agregá una frase de presentación"
                disabled={!isAdmin}
                onSave={onSaveTitle}
              />
            ) : null}

            <h1 className="max-w-2xl text-5xl font-black leading-[0.95] text-white sm:text-6xl lg:text-7xl">
              {cliente?.nombre || 'Tu espacio'}
            </h1>

            {hasDescription || isAdmin ? (
              <div className="mt-7 max-w-xl">
                <EditableTitle
                  as="p"
                  multiline
                  className="text-base font-medium leading-relaxed text-white/65 sm:text-lg"
                  value={cliente?.description}
                  placeholder="Contá qué hace único a tu espacio"
                  disabled={!isAdmin}
                  onSave={onSaveDescription}
                />
              </div>
            ) : null}
          </div>

          <div className="mt-12">
            <div className="mb-7 flex flex-wrap gap-x-6 gap-y-3 text-sm font-semibold text-white/65">
              {location ? (
                <span className="inline-flex items-center gap-2">
                  <MapPin size={16} className="text-primary-orange" />
                  {location}
                </span>
              ) : null}
              {upcomingCount > 0 ? (
                <span className="inline-flex items-center gap-2">
                  <CalendarDays size={16} className="text-primary-orange" />
                  {upcomingCount} {upcomingCount === 1 ? 'próximo evento' : 'próximos eventos'}
                </span>
              ) : null}
            </div>

            <div className="flex flex-wrap gap-3">
              {onRequestQuote ? (
                <button
                  type="button"
                  onClick={onRequestQuote}
                  className="inline-flex min-h-12 items-center gap-3 bg-primary-orange px-5 py-3 text-sm font-black text-white transition-colors hover:bg-orange-500"
                >
                  <CalendarDays size={18} />
                  Consultar disponibilidad
                  <ChevronRight size={18} />
                </button>
              ) : (
                <button
                  type="button"
                  onClick={onExplore}
                  className="inline-flex min-h-12 items-center gap-3 bg-primary-orange px-5 py-3 text-sm font-black text-white transition-colors hover:bg-orange-500"
                >
                  <CalendarDays size={18} />
                  {exploreLabel}
                  <ChevronRight size={18} />
                </button>
              )}
              {onRequestQuote ? (
                <button
                  type="button"
                  onClick={onExplore}
                  className="inline-flex min-h-12 items-center gap-3 border border-white/15 px-5 py-3 text-sm font-bold text-white transition-colors hover:border-white/35 hover:bg-white/5"
                >
                  {exploreLabel}
                  <ChevronRight size={18} />
                </button>
              ) : null}
              {onBrowseSpace ? (
                <button
                  type="button"
                  onClick={onBrowseSpace}
                  className="inline-flex min-h-12 items-center gap-3 border border-white/15 px-5 py-3 text-sm font-bold text-white transition-colors hover:border-white/35 hover:bg-white/5"
                >
                  <Images size={18} />
                  Ver el espacio
                </button>
              ) : null}
            </div>
          </div>
        </div>

        <div className="relative min-h-[300px] border-t border-white/10 lg:min-h-0 lg:border-l lg:border-t-0">
          {coverImage ? (
            <img
              src={coverImage}
              alt={`Vista de ${cliente?.nombre || 'este espacio'}`}
              className="absolute inset-0 h-full w-full object-cover"
            />
          ) : (
            <div className="absolute inset-0 flex items-end bg-[#1a1a1a] p-7 sm:p-10">
              <div className="max-w-sm">
                <p className="text-xs font-black uppercase tracking-[2px] text-primary-orange">Perfil público</p>
                <p className="mt-3 text-xl font-bold leading-snug text-white/70">
                  {isAdmin ? 'Subí fotos del espacio para que esta portada muestre su propuesta real.' : label}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
